export default "__VITE_ASSET__19170d67__"